import classNames from 'classnames';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'gatsby';
import Style from 'styles/components/design.module.scss';
import CommonStyle from 'styles/components/common.module.scss';
import useScrollAnimation from 'hooks/useScrollAnimation';
import stylish from 'images/design/stylish.png';
import designPartsEditor from 'images/design/design_parts_editor.png';
import designBackground from 'images/design/design_background_v2.png';
import designMenu from 'images/design/design_menu.png';
import designStorelogoPc from 'images/design/design_storelogo_pc_v2.png';
import designStyleMobile from 'images/design/design_style_v2.png';
import designPreviewPc from 'images/design/design_preview_pc.png';
import designPreviewMobile from 'images/design/design_preview_mobile.png';

// テンプレート画像（tablet版）
import templateTalent from 'images/design/template_talent_v2.png';
import templateHarvest from 'images/design/sample_HARVEST_tablet_v2.png';
import templateAqua from 'images/design/template_aqua.png';
import templateCozy from 'images/design/template_cozy_v2.png';
import templateOlive from 'images/design/template_olive_v2.png';
import templateNoren from 'images/design/template_noren.png';
import templateOcean from 'images/design/template_ocean.png';
import templateGreen from 'images/design/template_green.png';
import templateStride from 'images/design/template_stride_v2.png';
import templateLinen from 'images/design/template_linen.png';
import templateAtelier from 'images/design/template_atelier.png';

// ストアテンプレート画像（TemplateGallery用）
import storeBeige from 'images/store_templates/beige.png';
import storeBloom from 'images/store_templates/bloom.png';
import storeHarvest from 'images/store_templates/harvest.png';
import storeNormal from 'images/store_templates/normal.png';
import storeCalm from 'images/store_templates/calm.png';
import storeTraditional from 'images/store_templates/traditional.png';
import storeModern from 'images/store_templates/modern.png';
import storeCafe from 'images/store_templates/cafe.png';
import storeFashion from 'images/store_templates/fashion.png';
import storeChic from 'images/store_templates/chic.png';
import storeWamodern from 'images/store_templates/wamodern.png';
import storeNatural from 'images/store_templates/natural.png';
import storeStylish from 'images/store_templates/stylish.png';
import storeBeach from 'images/store_templates/beach.png';
import templateWellness from 'images/design/template_wellness.png';


const TopView = () => {
  return (
    <div className={Style.design__topView}>
      <div className={Style.design__topView__labelWrapper}>
        <span className={Style.eyebrow}>Design</span>
        <div className={Style.mask}>
          <div className={classNames(Style.design__topView__label, Style.revealText)}>
            かんたん、シンプルな操作で<br />
            あなた好みの見た目に
          </div>
        </div>
        <div className={Style.mask}>
          <div className={classNames(Style.design__topView__subLabel, Style.revealText, Style['revealText__delay1'])}>
            テンプレートを選ぶだけで、統一感のあるショップができあがります。
          </div>
        </div>
      </div>
      <img className={Style.design__topView__img} src={stylish} alt="テンプレートイメージ" />
    </div>
  );
}

const themes = [
  { img: templateTalent },
  { img: templateCozy },
  { img: templateAqua },
  { img: templateGreen },
  { img: templateOcean },
  { img: templateHarvest },
  { img: templateNoren },
  { img: templateStride },
  { img: templateOlive },
  { img: templateLinen },
  { img: templateAtelier },
  { img: templateWellness },
];

const Templetes = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.05);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  return (
    <div
      ref={sectionRef}
      className={classNames(Style.templetes, { [Style.templetesVisible]: isVisible })}
    >
      <div className={Style.templetesIntro}>
        <span className={Style.eyebrow}>Templates</span>
        <div className={Style.mask}>
          <h2 className={classNames(Style.templetesIntro__title, Style.revealText)}>作り方も、あなたが決める。</h2>
        </div>
        <div className={Style.mask}>
          <p className={classNames(Style.templetesIntro__text, Style.revealText, Style['revealText__delay1'])}>
            ゼロからオリジナルで作っても、<span className={Style.templetesIntro__highlight}>25種類の無料テンプレート</span>をベースにしてもOK。<br />
            デザインページから色や雰囲気を自由に変えられるから、<br />
            どちらの方法でも「あなただけのお店」になります。<br />
            <span className={Style.templetesIntro__highlight}>追加費用は一切かかりません。</span>
          </p>
        </div>
        <div className={Style.mask}>
          <p className={classNames(Style.templetesIntro__sample, Style.revealText, Style['revealText__delay2'])}>DESIGN SAMPLE</p>
        </div>
      </div>
      <div className={Style.templetesGrid}>
        {themes.map((theme, index) => (
          <div
            className={Style.templeteCard}
            key={`template-${index}`}
            onClick={() => setSelectedTemplate(theme)}
          >
            <img src={theme.img} alt="テンプレート" className={Style.img} />
          </div>
        ))}
      </div>
      {selectedTemplate && (
        <div className={Style.modal} onClick={() => setSelectedTemplate(null)}>
          <div className={Style.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={Style.modalClose} onClick={() => setSelectedTemplate(null)}>×</button>
            <img src={selectedTemplate.img} alt="テンプレート" className={Style.modalImg} />
          </div>
        </div>
      )}
    </div>
  );
};

// パーツデータ（ブランドカラー #0071b9 ベースで統一）
const partsData = [
  { icon: 'T', name: 'タイトル' },
  { icon: 'A', name: 'テキスト' },
  { icon: '\u{1F5BC}\uFE0E', name: '画像+テキスト' },
  { icon: '\u{1F4F7}\uFE0E', name: '画像' },
  { icon: '\u25B6\uFE0E', name: 'スライドショー' },
  { icon: '\u{1F3AC}\uFE0E', name: '動画' },
  { icon: '\u266A', name: 'TikTok動画' },
  { icon: '\u{1F310}\uFE0E', name: 'SNSリンク' },
  { icon: '\u21A9\uFE0E', name: 'シェアボタン' },
  { icon: '\u25A3', name: 'ボタン' },
  { icon: '\u2630', name: 'カテゴリー' },
  { icon: '\u{1F6D2}\uFE0E', name: '商品一覧' },
  { icon: '\u{1F4E2}\uFE0E', name: 'NEWS' },
  { icon: '\u2015', name: '区切り線' },
  { icon: '\u2605', name: 'おすすめ商品' },
];

// セクション1: Customize（パーツ紹介）
const PartsSection = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.1);

  return (
    <section
      ref={sectionRef}
      className={classNames(Style.partsSection, { [Style.partsSectionVisible]: isVisible })}
    >
      <div className={Style.partsSectionInner}>
        <span className={Style.eyebrow}>Customize</span>
        <div className={Style.mask}>
          <h2 className={classNames(Style.partsSection__title, Style.revealText)}>
            パーツを選んで、ドラッグするだけ。
          </h2>
        </div>
        <div className={Style.mask}>
          <p className={classNames(Style.partsSection__subtitle, Style.revealText, Style['revealText__delay1'])}>
            タイトル・画像・動画・商品一覧・SNSなど<br />
            <span className={Style.partsSection__highlight}>15種類のパーツ</span>を自由に組み合わせて、あなただけのショップを作れます。<br />
            コードの知識は一切不要です。
          </p>
        </div>

        <div className={Style.editorPreview}>
          <div className={Style.editorPreview__bar}>
            <span className={classNames(Style.editorPreview__dot, Style['editorPreview__dot--red'])} />
            <span className={classNames(Style.editorPreview__dot, Style['editorPreview__dot--yellow'])} />
            <span className={classNames(Style.editorPreview__dot, Style['editorPreview__dot--green'])} />
          </div>
          <div className={Style.editorPreview__body}>
            <img src={designPartsEditor} alt="パーツ編集画面" className={Style.editorPreview__img} />
          </div>
        </div>

        <div className={Style.partsCount}>
          <span className={Style.partsCount__num}>15</span>種類のパーツ、すべて無料
        </div>

        <div className={Style.partsGrid}>
          {partsData.map((part, index) => (
            <div
              className={Style.partsItem}
              key={`part-${index}`}
              style={{ transitionDelay: `${0.05 * index}s` }}
            >
              <span className={Style.partsItem__icon}>
                {part.icon}
              </span>
              <span className={Style.partsItem__name}>{part.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// セクション2: Brand Identity（背景・メニュー・ロゴ・スタイル）
const BrandIdentitySection = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.1);

  return (
    <section
      ref={sectionRef}
      className={classNames(Style.brandSection, { [Style.brandSectionVisible]: isVisible })}
    >
      <div className={Style.brandSectionInner}>
        <span className={Style.eyebrow}>Brand Identity</span>
        <div className={Style.mask}>
          <h2 className={classNames(Style.brandSection__title, Style.revealText)}>
            お店の世界観を、すみずみまで。
          </h2>
        </div>
        <div className={Style.mask}>
          <p className={classNames(Style.brandSection__subtitle, Style.revealText, Style['revealText__delay1'])}>
            背景・メニュー・ロゴ・フォント・カラー。<br />
            細部までカスタマイズできるから、あなたのブランドがそのまま形になります。
          </p>
        </div>

        <div className={Style.featuresGrid}>
          <div className={Style.featureCard}>
            <img src={designBackground} className={Style.featureCard__img} alt="背景編集画面" />
            <div className={Style.featureCard__body}>
              <span className={Style.featureCard__tag}>Background</span>
              <h3 className={Style.featureCard__title}>背景の変更</h3>
              <p className={Style.featureCard__text}>
                カラー1色、またはお好きな画像で背景を設定。<br />
                <strong>メインエリアとサブエリア</strong>で別々にカスタマイズできるから、
                ページごとに異なる雰囲気を演出できます。
              </p>
            </div>
          </div>

          <div className={Style.featureCard}>
            <img src={designMenu} className={Style.featureCard__img} alt="メニュー編集画面" />
            <div className={Style.featureCard__body}>
              <span className={Style.featureCard__tag}>Menu</span>
              <h3 className={Style.featureCard__title}>メニューの変更</h3>
              <p className={Style.featureCard__text}>
                表示名・順番・レイアウト・スタイル・文字色を自由に変更。<br />
                <strong>カスタムリンク</strong>や<strong>フリーページ</strong>の追加も。
                外部サイトへのリンクも簡単に設置できます。
              </p>
            </div>
          </div>

          <div className={Style.featureCard}>
            <img src={designStorelogoPc} className={Style.featureCard__img} alt="ストアロゴ設定画面" />
            <div className={Style.featureCard__body}>
              <span className={Style.featureCard__tag}>Store Logo</span>
              <h3 className={Style.featureCard__title}>ストアロゴの設定</h3>
              <p className={Style.featureCard__text}>
                テキストまたは画像でロゴを設定。<br />
                <strong>PC・スマホそれぞれ別のロゴ</strong>を設定でき、
                フォント・サイズ・配置も自由に調整できます。
              </p>
            </div>
          </div>

          <div className={Style.featureCard}>
            <img src={designStyleMobile} className={Style.featureCard__img} alt="スタイル設定画面" />
            <div className={Style.featureCard__body}>
              <span className={Style.featureCard__tag}>Style</span>
              <h3 className={Style.featureCard__title}>フォント・カラーの統一</h3>
              <p className={Style.featureCard__text}>
                ストア全体の<strong>フォント</strong>と<strong>テキストカラー</strong>を
                ワンクリックで統一。<br />
                お店の雰囲気にぴったりのスタイルに仕上がります。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// セクション3: Preview（PC/スマホプレビュー タブ切替 + 5秒自動切替）
const previewTabs = [
  { key: 'pc', label: 'PC表示', img: designPreviewPc, alt: 'PC表示プレビュー' },
  { key: 'mobile', label: 'Mobile表示', img: designPreviewMobile, alt: 'スマホ表示プレビュー' },
];

const PreviewSection = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.1);
  const [activeTab, setActiveTab] = useState('pc');
  const timerRef = useRef(null);

  const startAutoSwitch = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActiveTab((prev) => (prev === 'pc' ? 'mobile' : 'pc'));
    }, 5000);
  }, []);

  useEffect(() => {
    startAutoSwitch();
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [startAutoSwitch]);

  const handleTabClick = (key) => {
    setActiveTab(key);
    startAutoSwitch();
  };

  return (
    <section
      ref={sectionRef}
      className={classNames(Style.previewSection, { [Style.previewSectionVisible]: isVisible })}
    >
      <div className={Style.previewSectionInner}>
        <div className={Style.previewShowcase}>
          <div className={Style.previewShowcase__content}>
            <span className={Style.eyebrow}>Preview</span>
            <div className={Style.mask}>
              <h2 className={classNames(Style.previewShowcase__title, Style.revealText)}>
                PC・スマホ、<br />
                両方の見え方をその場で確認。
              </h2>
            </div>
            <div className={Style.mask}>
              <p className={classNames(Style.previewShowcase__text, Style.revealText, Style['revealText__delay1'])}>
                編集しながらリアルタイムでプレビュー。<br />
                PC表示とスマホ表示をワンタッチで切り替えられるから、<br />
                公開前に安心して仕上がりをチェックできます。
              </p>
            </div>
          </div>

          <div className={Style.previewVisual}>
            <div className={Style.previewTabBar}>
              {previewTabs.map((tab) => (
                <button
                  key={tab.key}
                  className={classNames(Style.previewTabBtn, {
                    [Style.previewTabBtnActive]: activeTab === tab.key,
                  })}
                  onClick={() => handleTabClick(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className={Style.previewImgWrap}>
              {previewTabs.map((tab) => (
                <img
                  key={tab.key}
                  src={tab.img}
                  alt={tab.alt}
                  className={classNames(Style.previewImg, {
                    [Style.previewImgActive]: activeTab === tab.key,
                  })}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// TemplateGallery データ（表示順: beige→bloom→harvest→...→beach）
const galleryTemplates = [
  { id: 'beige', name: 'BEIGE', cat: 'スキンケア・美容', img: storeBeige, isNew: true, tags: ['上質感', '美容', '余白設計'], desc: '高級スキンケア・化粧品・美容サロングッズの販売に最適なテンプレート。グレーベージュの落ち着いた背景と余白を活かした構成で、ブランドの上質感を自然に演出します。' },
  { id: 'bloom', name: 'BLOOM', cat: 'コスメ・トレンド', img: storeBloom, isNew: true, tags: ['SNS映え', 'コスメ', 'トレンド'], desc: 'カラーコスメやスキンケアを販売する方に向けた、明るくトレンド感のあるECテンプレート。SNSからの流入ユーザーが思わず買いたくなるデザインです。' },
  { id: 'harvest', name: 'HARVEST', cat: '産直・生産者', img: storeHarvest, isNew: true, tags: ['産直', '生産者', 'ストーリー'], desc: '産直野菜・お米・加工食品など、食にこだわりを持つ生産者向けテンプレート。ストーリーセクションで生産背景を丁寧に伝え、ファンを育てるECが作れます。' },
  { id: 'normal', name: 'NORMAL', cat: 'シンプル・万能', img: storeNormal, isNew: false, tags: ['白背景', 'シンプル', '初心者向け'], desc: '「まず商品を見てほしい」ショップに向いた、究極にシンプルなデザイン。白背景が商品の色・形を正確に伝え、購入判断をスムーズにする使いやすいレイアウトです。' },
  { id: 'calm', name: 'CALM', cat: 'ナチュラルライフ・グリーン', img: storeCalm, isNew: false, tags: ['グリーン', '雑貨', '余白設計'], desc: 'インテリアグリーン・ドライフラワー・ガーデニング雑貨など、ナチュラルライフ系ショップ向けデザイン。落ち着いた配色と余白設計で、ゆっくり商品を見てもらえる導線を実現します。' },
  { id: 'traditional', name: 'TRADITIONAL', cat: '和食材・伝統工芸', img: storeTraditional, isNew: false, tags: ['和紙調', '日本酒', '伝統工芸'], desc: '日本酒・焼酎・伝統工芸品・和食材など、和の世界観を大切にしたいショップにぴったりのテンプレート。和紙調の背景と左サイドナビが、品のある日本的なECの雰囲気を作り出します。' },
  { id: 'modern', name: 'MODERN', cat: 'シンプルモダン', img: storeModern, isNew: false, tags: ['クリーン', 'カテゴリ導線', '大量商品対応'], desc: '白を基調としたクリーンなレイアウトで、どんな商品写真も映えるシンプルモダンなデザイン。カテゴリ導線とニュースセクションが整理されており、商品数の多いショップにも対応しやすい構成です。' },
  { id: 'cafe', name: 'CAFE', cat: 'カフェ・飲食', img: storeCafe, isNew: false, tags: ['実店舗連携', '飲食', '温かみ'], desc: '「お店の雰囲気ごとオンラインで届けたい」カフェ・飲食系ショップへ。店内写真をそのままメインビジュアルに使える構成で、実店舗の温かさをそのままECに落とし込めます。' },
  { id: 'fashion', name: 'FASHION', cat: 'セレクトショップ', img: storeFashion, isNew: false, tags: ['セレクト', 'カテゴリ導線', '個性'], desc: '着まわしやすくて、でもどこか個性がある。そんな服だけを揃えたセレクトショップ向けのテンプレート。カテゴリ導線が整理されており、今日の気分で商品を探しやすい構成です。' },
  { id: 'chic', name: 'CHIC', cat: 'ギフト・ライフスタイル', img: storeChic, isNew: false, tags: ['ギフト', 'こだわり', 'ライフスタイル'], desc: '落ち着いたトーンとスタイリッシュなレイアウトで、食とライフスタイルにこだわりを持つ顧客層に刺さるECテンプレート。ギフト需要が高い商材との相性が特に良いデザインです。' },
  { id: 'wamodern', name: 'WAMODERN', cat: '和スイーツ・茶', img: storeWamodern, isNew: false, tags: ['抹茶', '和紙風', '和スイーツ'], desc: '抹茶・緑茶・和スイーツなど、和テイストの食品ECに最適なテンプレート。和紙風の背景とモダンなレイアウトのバランスが、伝統的な商品をおしゃれに見せます。' },
  { id: 'natural', name: 'NATURAL', cat: '食品・雑貨・クラフト', img: storeNatural, isNew: false, tags: ['親しみやすい', 'グリッド表示', 'リピーター'], desc: 'ナチュラルで親しみやすいデザインが、食品・雑貨・クラフト系ショップと相性抜群。人気商品をグリッドで一覧表示できる構成で、リピーターが商品を探しやすいECが作れます。' },
  { id: 'stylish', name: 'STYLISH', cat: 'フード・デリ', img: storeStylish, isNew: false, tags: ['ダーク木目', 'フード', '食欲訴求'], desc: 'こだわりの食材・デリ・料理キットなど、フード系ECにおすすめのテンプレート。ダーク木目背景が料理写真の色味を引き立て、食欲をそそるビジュアルECが作れます。' },
  { id: 'beach', name: 'BEACH', cat: 'サーフ・アウトドア', img: storeBeach, isNew: false, tags: ['砂浜テクスチャ', 'サーフ', '抜け感'], desc: '海・サーフ・リゾートウェアなど、アウトドア系アパレルショップにおすすめのテンプレート。砂浜をイメージしたテクスチャ背景と抜け感のあるレイアウトで、ブランドの世界観をそのまま表現できます。' },
];

// TemplateGallery コンポーネント
const TemplateGallery = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.05);
  const [activeIdx, setActiveIdx] = useState(0);
  const thumbsRef = useRef(null);
  const sliderRef = useRef(null);

  const handleSelect = useCallback((idx) => {
    setActiveIdx(idx);
    if (sliderRef.current) sliderRef.current.value = idx;
    // サムネイルをスクロール追従
    if (thumbsRef.current) {
      const thumbs = thumbsRef.current.querySelectorAll(`.${Style.gallery__thumb}`);
      if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, []);

  const handleSliderInput = useCallback((e) => {
    const val = parseFloat(e.target.value);
    const idx = Math.round(val);
    if (idx !== activeIdx) handleSelect(idx);
  }, [activeIdx, handleSelect]);

  const handleSliderChange = useCallback((e) => {
    const idx = Math.round(parseFloat(e.target.value));
    e.target.value = idx;
    handleSelect(idx);
  }, [handleSelect]);

  const active = galleryTemplates[activeIdx];

  return (
    <div
      ref={sectionRef}
      className={classNames(Style.gallery, { [Style.galleryVisible]: isVisible })}
    >
      <div style={{ textAlign: 'center', marginBottom: '48px', marginTop: '60px' }}>
        <span className={Style.gallery__eyebrow}>Template Gallery</span>
        <h2 className={Style.gallery__title}>25種類のテンプレートが、すべて無料。</h2>
        <p className={Style.gallery__sub}>
          コスメ・食品・アパレル・ハンドメイドなど、さまざまな業種やブランドイメージに合わせて選べるテンプレートをすべて無料でご用意。<br />
          気に入ったデザインを選ぶだけで、本格的なECショップがすぐに作れます。
        </p>
      </div>

      {/* 2行タブ */}
      <div className={Style.gallery__tabs}>
        {galleryTemplates.map((t, i) => (
          <button
            key={t.id}
            className={classNames(Style.gallery__tab, { [Style.gallery__tabActive]: i === activeIdx })}
            onClick={() => handleSelect(i)}
          >
            {t.name}
          </button>
        ))}
      </div>

      {/* 2カラム詳細 */}
      <div className={Style.gallery__detail} key={active.id}>
        <div className={Style.gallery__imgWrap}>
          {active.isNew && <span className={Style.gallery__badge}>NEW</span>}
          <img src={active.img} alt={active.name} className={Style.gallery__img} />
        </div>
        <div className={Style.gallery__info}>
          <div className={Style.gallery__name}>
            {active.name}
            {active.isNew && <span className={Style.gallery__nameBadge}>NEW</span>}
          </div>
          <div className={Style.gallery__cat}>{active.cat}</div>
          <p className={Style.gallery__desc}>{active.desc}</p>
          <div className={Style.gallery__tags}>
            {active.tags.map((tag) => (
              <span key={tag} className={Style.gallery__tag}>{tag}</span>
            ))}
          </div>
        </div>
      </div>

      {/* サムネイルレール */}
      <div className={Style.gallery__thumbsWrap}>
        <div className={Style.gallery__thumbs} ref={thumbsRef}>
          {galleryTemplates.map((t, i) => (
            <button
              key={t.id}
              className={classNames(Style.gallery__thumb, { [Style.gallery__thumbActive]: i === activeIdx })}
              onClick={() => handleSelect(i)}
            >
              {t.isNew && <span className={Style.gallery__thumbBadge}>NEW</span>}
              <img src={t.img} alt={t.name} className={Style.gallery__thumbImg} />
              <span className={Style.gallery__thumbLabel}>{t.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* スライダー */}
      <div className={Style.gallery__sliderWrap}>
        <input
          type="range"
          className={Style.gallery__slider}
          ref={sliderRef}
          min="0"
          max={galleryTemplates.length - 1}
          defaultValue="0"
          step="0.01"
          onInput={handleSliderInput}
          onChange={handleSliderChange}
        />
      </div>

      {/* フッターテキスト */}
      <div className={Style.gallery__footer}>
        <h3 className={Style.gallery__footerTitle}>ほかにも無料テンプレートを<br className={Style.gallery__spBr} />多数ご用意しています。</h3>
        <p className={Style.gallery__footerText}>
          業種・ターゲット・世界観に合わせた豊富な<br className={Style.gallery__spBr} />テンプレートラインナップを無料でご用意。<br />
          無料登録後すぐにすべてのデザインを<br className={Style.gallery__spBr} />お試しいただけます。<br /><br />
          まずは登録して、あなたのお店にぴったりの<br className={Style.gallery__spBr} />テンプレートを探してみてください。
        </p>
        <Link className={Style.gallery__footerBtn} to="/application">
          無料でお試し登録する
        </Link>
      </div>
    </div>
  );
};

const Design = ({ showDetails = false }) => {
  const [sectionRef, isVisible] = useScrollAnimation(0.01);

  return (
    <section ref={sectionRef} className={classNames(Style.design, { [Style.design__visible]: isVisible })}>
      <TopView />
      {showDetails && (
        <>
          <PartsSection />
          <BrandIdentitySection />
          <PreviewSection />
        </>
      )}
      <Templetes />
      {showDetails && <TemplateGallery />}
      {!showDetails && (
        <div className={CommonStyle.moreBtnWrapper}>
          <Link className={CommonStyle.moreBtn} to="/design/">
            詳しくはこちら
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      )}
    </section>
  );
};

export default Design;
